

import { GoogleMap, Marker } from '@react-google-maps/api'
import { useCallback, useRef, useState } from 'react';
import styled from 'styled-components'
import { IoLocationSharp } from "react-icons/io5";
import { useDispatch } from 'react-redux';
import { setRouteItem, setSelectedRouteItem, updateRouteItem } from '../../features/addLoad/addLoadSlice';
import axios from 'axios';
import { getAdresFromLatLng } from '../../features/address/addressSlice';
import { useSelector } from 'react-redux';

const Container = styled.div`
  width: 100%;
  height: 100%;

  .map-container{
    width: 100%;
    height: 100%;

    .center-marker {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%); /* Marker'ın haritanın ortasında yer almasını sağlar */
    transition: transform 0.3s ease-in-out; /* Yumuşak geçiş ekler */
    font-size: 35px;
    color: ${({isfirstChanged}) => isfirstChanged ? "#E85446" : "#989696"} ; /* Marker rengi */
    z-index: 1;
  }
  }
`

const SingleRouteMap = () => {

    const mapRef = useRef(null);
    const {getAdresFromLatLngResult} = useSelector(state => state.address);
    const { selectedRouteItem,adresSelectMapZoom } = useSelector((state) => state.addLoad);

    const dispatch = useDispatch();

const onMapLoad = useCallback(
  (map) => {
    mapRef.current = map;
    map.setMapTypeId("hybrid");
  },
  [mapRef]
);

    const onMapDragEnd = useCallback((map) => {
        if (mapRef.current) {
            const newCenter = mapRef.current?.getCenter()?.toJSON();
            dispatch(getAdresFromLatLng({lat: newCenter.lat, lng: newCenter.lng, isFromSingleRouteMap: true}));
            dispatch(setSelectedRouteItem({...selectedRouteItem, locationData: {...selectedRouteItem.locationData, googleLat: newCenter.lat, googleLng: newCenter.lng }}));
          }
      }, []);

      

  return (
    <Container isfirstChanged={selectedRouteItem.locationData.isfirstChanged}>
        <GoogleMap
            mapContainerClassName="map-container"
            center={{lat: selectedRouteItem.locationData.googleLat, lng: selectedRouteItem.locationData.googleLng}}
            zoom={adresSelectMapZoom}
                    mapTypeId="hybrid"

            onDragEnd={(e) => onMapDragEnd(e)}
            onLoad={onMapLoad}
            options={{
                fullscreenControl: false, // Tam ekran kontrolünü kapatır
                streetViewControl: false, // Sokak görünümü kontrolünü kapatır
                mapTypeControl: false, // Harita tipi kontrolünü kapatır
                scrollwheel: false
            }}
        >
              {/* Haritanın tam ortasına marker yerleştiriliyor */}
        <div

        >


<IoLocationSharp className="center-marker" />
            
        </div>

        </GoogleMap>

    </Container>
  )
}

export default SingleRouteMap